export const schemeDetailsPageTranslations = {
    en: {
        noDataAvailable: "No data available",
        noDescription: "No description available",
        requiredDocuments: "Required Documents",
        noDocumentsRequired: "No Documents Required",
        coveredDiseases: "Covered Diseases / Procedures",
        noDiseasesCovered: "No Diseases / Procedures Covered",
        eligibilityCriteria: "Eligibility Criteria",
        noEligibility: "No eligibility criteria available",
        createdOn: "Created on",
        notAvailable: "N/A"
    },
    mr: {
        noDataAvailable: "डेटा उपलब्ध नाही",
        noDescription: "वर्णन उपलब्ध नाही",
        requiredDocuments: "आवश्यक कागदपत्रे",
        noDocumentsRequired: "कोणतीही कागदपत्रे आवश्यक नाहीत",
        coveredDiseases: "समाविष्ट रोग / प्रक्रिया",
        noDiseasesCovered: "कोणतेही रोग / प्रक्रिया समाविष्ट नाहीत",
        eligibilityCriteria: "पात्रता निकष",
        noEligibility: "पात्रता निकष उपलब्ध नाहीत",
        createdOn: "तयार केले",
        notAvailable: "उपलब्ध नाही"
    }
};
